
<template>
  <div class="tab-area">

    <div class="tab-heading">

      <div class="tab" @click="handleTab(2)" :class="{active: tab === 1}">
        <i class="material-icons yellow">language</i>

        <div class="text">Hundreds of color themes, instantly</div>
      </div>

      <div class="tab" @click="handleTab(1)" :class="{active: tab === 2}">
        <i class="material-icons yellow">language</i>

        <div class="text">Filter outputs by theme style</div>
      </div>

      <div class="tab" @click="handleTab(3)" :class="{active: tab === 3}">
        <i class="material-icons yellow">language</i>

        <div class="text">Preview your colors in an interface</div>
      </div>

      <div class="tab" @click="handleTab(4)" :class="{active: tab === 4}">
        <i class="material-icons yellow">language</i>

        <div class="text">Toggle between a variety of UI types</div>
      </div>

    </div>

    <div class="tab-content" ref="content">

      <div class="tab" v-show="tab === 1">
        <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/hundreds-instantly_colorful.gif" alt=""/>
      </div>

      <div class="tab" v-show="tab === 2">
        <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/filter-by-style.gif" alt=""/>
      </div>

      <div class="tab" v-show="tab === 3">
        <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/see-in-UI_colorful.gif" alt=""/>
      </div>

      <div class="tab" v-show="tab === 4">
        <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/ui-types_colorful.gif" alt=""/>
      </div>

    </div>

    <div class="dots visible-phone">
      <div class="dot" @click="handleTab(1)" :class="{active: tab === 1}"></div>

      <div class="dot" @click="handleTab(2)" :class="{active: tab === 2}"></div>

      <div class="dot" @click="handleTab(3)" :class="{active: tab === 3}"></div>

      <div class="dot" @click="handleTab(4)" :class="{active: tab === 4}"></div>
    </div>

  </div>
</template>

<script>
import tab from './homeTab';

export default {
  name: 'home-sample-tab',
  ...tab,
};
</script>

<style lang="scss" scoped>
  @import '../../styles/_home';
</style>
